export const locale = {
    lang: 'ds',
    data: {
        'FIELDS': {
            'ProjectInfo': 'Projekt opgave information',
        },
    }
};

